export type ValidatorCallback = (error?: Error) => void
export type TranslateFn = (key: string) => string

/**
 * 校验是否为大于0的数字
 */
export function createPositiveNumberValidator(t: TranslateFn) {
  return (rule: unknown, value: unknown, callback: ValidatorCallback): void => {
    // 空值交给 required 去处理，这里只处理格式和数值范围
    if (value === null || value === undefined || value === '') {
      callback()
      return
    }

    const numberValue = Number(value)

    if (Number.isNaN(numberValue)) {
      callback(new Error(t('common.inputFormatP')))
      return
    }

    if (numberValue <= 0) {
      callback(new Error(t('common.greaterThanZeroP')))
      return
    }

    callback()
  }
}
